import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import { COLLABORATION_SIDEBAR_FAS_NAMESPACE, COMMENTING_FAS_NAMESPACE } from './constants';
export function getFrameworkAppSettings() {
  return getFrameworkDataSchemasClient().then(client => client.typeMetadata.get({
    appSettingNames: [COLLABORATION_SIDEBAR_FAS_NAMESPACE, COMMENTING_FAS_NAMESPACE]
  })).catch(() => null);
}